export default "__VITE_ASSET__c2b43d9b__"